export const SET_PROJECT = "SET_PROJECT";
export const CLEAR_PROJECT = "CLEAR_PROJECT";

export const SET_USER = "SET_USER";
export const CLEAR_USER = "CLEAR_USER";
